import React from 'react'
import moment from 'moment'
import TableValueAction from '../../../../../MuiTable/components/TableValueAction'
import InfoCpa from '../../../busquedaCpa/InfoCpa'

export const COLUMNS_CAMIONES_RECHAZADOS_BRUTO = [
  {
    name: 'fechaDeBruto',
    label: 'Fecha de bruto',
    options: {
      filter: false,
      sort: true,
      filterType: 'multiselect',
      customBodyRender: (fecha) => fecha ? <>{moment(fecha).format('DD-MM HH:mm')}</> : null
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: false,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'cartaDePorteAutomotor',
    label: 'Carta de porte',
    options: {
      filter: false,
      sort: true,
      customBodyRender: (numero) => {
        return (
          <>
            {numero
              ? <TableValueAction
                value={numero}
                title=' '
                content={<InfoCpa cpa={numero} />} />
              : null
            }
          </>
        )
      }
    }
  },
  {
    name: 'exportador',
    label: 'Exportador',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'balanceroDeBruto',
    label: 'Balancero',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'balanzaDeBruto',
    label: 'Balanza de bruto',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'rechazoEnPesado',
    label: 'Motivo de rechazo',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  }
]
